import { GlobalTokens } from "../../../@tokens/GlobalTokens";
import { BrandTokens } from "../../../@tokens/BrandTokens";
import { hexToRGB } from "../../../helpers/Colors/colors";

export const style: any = {
    theme: {

        motion: {
            transitionDuration: GlobalTokens.MotionSwitchSlow?.TransitionDuration,
            transitionTimingFunction: GlobalTokens.MotionSwitchSlow?.TransitionTimingFunction
        },

        label: {
            color: BrandTokens.NeutralColorLowPure,
            lineHeight: GlobalTokens.LineHeightDefault,
            fontWeight: BrandTokens.FontWeightMedium,
            fontSize: GlobalTokens.FontSizeXs,
            fontFamily: BrandTokens.FontFamily,
            paddingBottom: GlobalTokens.SpacingSizeNano,
            textAlign: 'left'
        },
        select: {
            // minWidth: '250px',
            width: '100%',
            height: '56px',
            backgroundColor: BrandTokens.NeutralColorHighPure,
            borderRadius: GlobalTokens.BorderRadiusMd,
            border: `${GlobalTokens.BorderWidthHairline} solid ${BrandTokens.NeutralColorLowDark}`,
            padding: `${GlobalTokens.SpacingSizeXxxs}`,
            lineHeight: GlobalTokens.LineHeightDefault,
            fontWeight: BrandTokens.FontWeightRegular,
            fontSize: GlobalTokens.FontSizeXs,
            fontFamily: BrandTokens.FontFamily,
            textAlign: 'left',
            color: BrandTokens.NeutralColorLowPure
        },
        placeholder: {
            fontWeight: BrandTokens.FontWeightRegular,
            color: hexToRGB(BrandTokens.NeutralColorLowPure, GlobalTokens.OpacityLevelIntense),

        },
        helper: {
            marginTop: GlobalTokens.SpacingSizeNano,
            color: BrandTokens.NeutralColorLowPure,
            fontSize: GlobalTokens.FontSizeXxs,
            fontWeight: BrandTokens.FontWeightRegular,
            fontFamily: BrandTokens.FontFamily,
            lineHeight: GlobalTokens.LineHeightDefault,
            icon: {
                paddingRight: GlobalTokens.SpacingSizeQuarck
            }
        },
        menuItem: {
            marginTop: GlobalTokens.SpacingSizeNano,
            borderWidth: GlobalTokens.BorderWidthThin,
            borderColor: BrandTokens.NeutralColorHighMedium,
            borderRadius: GlobalTokens.BorderRadiusMd,
            padding: GlobalTokens.SpacingInsetSizeXs,
            boxShadow: `${GlobalTokens.ShadowLevel2} ${hexToRGB(BrandTokens.NeutralColorLowPure, GlobalTokens.OpacityLevelLight)}`,
            backgroundColor: BrandTokens.NeutralColorHighPure,
        },
        menuItemLabel: {
            height: '56px',
            padding: `0 ${GlobalTokens.SpacingSizeXs}`,
            borderRadius: GlobalTokens.BorderRadiusMd,
            fontWeight: BrandTokens.FontWeightMedium
        },
        states: {
            hover: {
                select: {
                    backgroundColor: hexToRGB(BrandTokens.BrandColorPrimaryLight, GlobalTokens.OpacityLevelMedium)
                }
            },
            focus: {
                outline: `${GlobalTokens.BorderWidthThin} solid ${BrandTokens.HighlightColorPure}`,
                input: {
                    backgroundColor: hexToRGB(BrandTokens.BrandColorPrimaryLight, GlobalTokens.OpacityLevelMedium)
                }
            },
            actived: {
                label: {
                    color: BrandTokens.BrandColorPrimaryPure
                },
                select: {
                    borderColor: BrandTokens.BrandColorPrimaryPure
                },
                menuItem: {
                    // padding: `0 ${GlobalTokens.SpacingSizeXxs}`
                },
                menuItemLabel: {
                    backgroundColor: hexToRGB(BrandTokens.BrandColorPrimaryLight, GlobalTokens.OpacityLevelMedium),
                    color: BrandTokens.BrandColorPrimaryDark,
                    padding: `0 ${GlobalTokens.SpacingSizeXxs}`
                },
            },
            error: {
                label: {
                    color: BrandTokens.FeedbackColorErrorPure
                },
                select: {
                    borderColor: BrandTokens.FeedbackColorErrorPure,
                    backgroundColor: BrandTokens.FeedbackColorErrorLight
                },
                helper: {
                    color: BrandTokens.FeedbackColorErrorPure
                }
            },
            disabled: {
                label: {
                    color: hexToRGB(BrandTokens.NeutralColorLowPure, GlobalTokens.OpacityLevelMedium)
                },
                select: {
                    borderColor: hexToRGB(BrandTokens.NeutralColorLowPure, GlobalTokens.OpacityLevelMedium)
                },
                placeholder: {
                    color: hexToRGB(BrandTokens.NeutralColorLowPure, GlobalTokens.OpacityLevelMedium)
                },
                helper: {
                    color: hexToRGB(BrandTokens.NeutralColorLowPure, GlobalTokens.OpacityLevelMedium)
                }
            }
        }
    }
}